<template>
  <div class="confirm-layout">
    <div class="alert alert-success" v-if="currentDrugInDevice">
      此藥盒目前數量/上限: {{ currentDrugInDevice.stock }} / {{ currentDrugInDevice.max_stock }}
    </div>
    <div class="alert alert-success" v-else>
      補藥至未使用藥盒
    </div>
    
    <ConfirmText
      v-if="currentProgress === 'setPatch'"
      :inputLabel="'確認批號'"
      :defaultContent="defaultPatchNumber"
      :editable="patchEditable"
      v-on:setText="getPatch"/>

    <MaxStockSet
      v-if="currentProgress === 'setMaxAmount'"
      v-on:setMaxAmountData="getMaxAmountData"
    />

    <ConfirmExpirationDate 
      v-if="currentProgress === 'setExpirationDate'" 
      :defaultExpirationDate="defaultExpirationDate"
      :editable="dateEditable"
      v-on:setExpirationDate="getExpirationDate"/>

    <PackAndPieceSet
      v-if="currentProgress === 'setRefillNum'" 
      :defaultAmount="defaultRefillAmount" 
      :inputLabel="'補充數量'"
      v-on:setNum="getPatchAndPieceData" />

    <rx-check-barcode v-if="currentProgress === 'rxCheck'" v-on:confirmRx="confirmRx" />

    <ActionWrap 
    v-if="currentProgress === 'action'" 
    v-on:setActionData="getActionData"
    :startType="startType"
    :amountPayload="amountPayload" 
    />

    <Loader v-if="currentProgress === 'finish'"/>
  </div>
</template>


<script>
import _ from 'lodash';
import ConfirmText from '../flowComp/TextInput';
import ConfirmExpirationDate from '../flowComp/DateSelection';
import ConfirmStorage from '../flowComp/NumberSet';
import PackAndPieceSet from '../flowComp/PackAndPieceSet';
import ActionWrap from './ActionWrap';
import Loader from '../common/Loader';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';
import MaxStockSet from '../flowComp/MaxStockSet';


export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: ['startType'],
  data() {
    return {
      defaultAmount: 0,
      maxAmount: undefined,
      actionData: [],
      patch: '',
      expirationDate: '',
      refillNum: 0,
      amountPayload: null,
      reviewer: undefined,
    };
  },
  components: {
    ConfirmText,
    ConfirmExpirationDate,
    ConfirmStorage,
    PackAndPieceSet,
    ActionWrap,
    Loader,
    RxCheckBarcode,
    MaxStockSet,
  },
  methods: {
    getMaxAmountData(payload) {
      this.patch = payload.patchNumber;
      this.maxAmount = payload.amount;
      this.nextProgress();
    },
    confirmRx(reviewer) {
      this.reviewer = reviewer.id;
      this.nextProgress();
    },
    getPatch(text) {
      if (this.startType === 'createNewDrugStorage') {
        this.patch = text;
        this.nextProgress();
      } else {
        if (text !== this.currentDrugInDevice.patch_number && this.patchEditable === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '補充批號與原藥盒批號不同，請確認批號',
          });
        } else {
          if (this.currentDrugInDevice.medication.restrained_class > 0 && text === '') {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '管制藥物必須設定批號',
            });
          } else {
            this.patch = text;
            this.nextProgress();
          }
          // this.$store.commit('SET_CURRENT_STEP', 'setExpirationDate');
        }
      }
    },
    getExpirationDate(date) {
      this.expirationDate = date;
      this.nextProgress();
    },
    getPatchAndPieceData(payload) {
      this.amountPayload = payload;
      this.refillNum = parseInt(payload.amount, 10);
      if ((this.refillNum + this.currentDrugInDevice.stock) > this.currentDrugInDevice.max_stock) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '補充數量不能大於總最大庫存' });
      } else {
        // start action.
        this.nextProgress();
      }
    },
    getActionData(data) {
      this.actionData = data;
      this.nextProgress();
      setTimeout(() => { this.emitData(); }, 100);
    },
    saveDrugStorage() {
      this.actionData.forEach(async (data) => {
        const sentData = {
          id: this.currentDrugInDevice.id,
          device: data.device,
          stock: this.currentDrugInDevice.stock + data.num, // only update here.
          max_stock: this.currentDrugInDevice.max_stock,
          expired_date: this.expirationDate,
          patch_number: this.patch,
          medication: this.currentDrugInDevice.medication.id,
          number1: data.num,
          review_employee: this.reviewer,
          pack_count: data.packCount + this.currentDrugInDevice.pack_count,
          type: 'REFILL',
        };

        const refillItem = _.find(this.$store.state.drugInDevice.RefillDrugInDeviceList, (o) => { return o.id === sentData.id; });
        if (refillItem) {
          await this.instance.delete(`/api/refill-order/${refillItem.refillId}/`);
        }
        await this.instance.put(`/api/drug-storage/${sentData.id}/`, sentData);
        await this.$store.dispatch('updateCurrentDrugInDevice', sentData.id);
        this.$emit('confirmationFinish');
        this.resetProgress();
      });
    },
    createNewDrugStorageForRefill() {
      const data = this.actionData[0];
      const sentData = {
        // id: this.currentDrugInDevice.id,
        device: data.device,
        stock: data.num, // only update here.
        max_stock: this.maxAmount,
        expired_date: this.expirationDate,
        patch_number: this.patch,
        medication: this.$store.state.drug.selectedDrug.id,
        number1: data.num,
        review_employee: this.reviewer,
        pack_count: data.packCount,
        type: 'REFILL',
      };

      this.instance.post('/api/drug-storage/', sentData)
      .then(() => {
        this.$emit('confirmationFinish');
        this.resetProgress();
      });
    },
    emitData() {
      console.log('confirm finished');
      if (this.startType === 'createNewDrugStorage') {
        this.createNewDrugStorageForRefill();
      } else {
        this.saveDrugStorage();
      }
    },
    calcRefillPayload() {
      if (this.startType === 'createNewDrugStorage') {
        this.amountPayload = {
          packCount: 0,
          pieceCount: 0,
          amount: 0,
          maxAmount: this.maxAmount,
        };
      } else {
        let packCount;
        let pieceCount;
        // automatically calulate the refill amount.
        // const defaultRefillAmount = this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock;
        // if (this.selectedDrug.pack_content !== 0) {
        //   packCount = Math.floor(defaultRefillAmount / this.selectedDrug.pack_content);
        //   pieceCount = defaultRefillAmount % this.selectedDrug.pack_content;
        // } else {
        //   packCount = 0;
        //   pieceCount = defaultRefillAmount;
        // }

        const defaultRefillAmount = 0;
        this.amountPayload = {
          packCount,
          pieceCount,
          amount: defaultRefillAmount,
        };
      }
    },
  },
  mounted() {
    // set device
    const medId = this.$store.state.drug.selectedDrugID;
    this.$store.dispatch('getDrugInDevicesWithSameDrug', medId);
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },
  computed: {
    selectedDrug() {
      return this.$store.getters.selectedDrug;
    },
    patchEditable() {
      if (this.currentDrugInDevice && this.currentDrugInDevice.stock === 0) {
        return true;
      }
      if (this.startType === 'createNewDrugStorage') {
        return true;
      }
      return false;
    },
    dateEditable() {
      if (this.currentDrugInDevice && this.currentDrugInDevice.stock === 0) {
        return true;
      }
      if (this.startType === 'createNewDrugStorage') {
        return true;
      }
      return false;
    },
    defaultPatchNumber() {
      if (this.currentDrugInDevice) return this.currentDrugInDevice.patch_number;
      return undefined;
    },
    defaultExpirationDate() {
      if (this.currentDrugInDevice) return this.currentDrugInDevice.expired_date;
      return undefined;
    },
    defaultRefillAmount() {
      if (this.currentDrugInDevice) return (this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock);
      return undefined;
    },
  },
  watch: {
    currentProgress(val) {
      console.log(val);
      if (val === 'autoCalcRefillPayload') {
        this.calcRefillPayload();
        this.nextProgress();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?4a427706